import React from 'react';
import ReactDOMServer from 'react-dom/server';
import DriverInfoWindow from './DriverInfoWindow';
import workingTruckMarker from './markers/working-truck.png';
import originMarker from './markers/origin.png';
import destinationMarker from './markers/destination.png';
function createMarker(item, icon, info) {
    return {
        id: item._id,
        icon,
        position: {
            lat: item.coords[1],
            lng: item.coords[0],
        },
        info,
        jobCount: (item.jobs || []).length,
        pendingCount: 0,
    };
}
function createDriverMarker(item) {
    return {
        id: item._id,
        position: {
            lat: item.coords[1],
            lng: item.coords[0],
        },
    };
}
function createMarkersForShipment(shipment) {
    if (!shipment) {
        return [];
    }
    const markers = [
        createMarker(shipment.origin[0], {
            url: originMarker,
            scaledSize: new google.maps.Size(50, 60),
        }, 'Origin'),
        createMarker(shipment.destination[0], {
            url: destinationMarker,
            scaledSize: new google.maps.Size(50, 60),
        }, 'Destination'),
    ];
    // Use driver.carrier to detect a populated driver object, since that is
    // one of several fields needed by DriverInfoWindow. Some shipment updates
    // don't populate it, but eventually the poll will provide it.
    if (shipment.driver && shipment.driver.carrier) {
        markers.push(createMarker(shipment.driver, {
            url: workingTruckMarker,
            scaledSize: new google.maps.Size(35, 35),
        }, ReactDOMServer.renderToString(React.createElement(DriverInfoWindow, { shipment: shipment, driver: shipment.driver, carrierName: shipment.driver.carrier && shipment.driver.carrier.name ? shipment.driver.carrier.name : "" }))));
    }
    return markers;
}
export default {
    createMarkersForShipment,
    createMarker,
    createDriverMarker,
};
